var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidelineBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.752,
    height: 141.522,
    viewBox: "0 0 93.752 141.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154538",
    "data-name": "Rectangle 154538",
    width: 44.675,
    height: 44.031,
    transform: "translate(-4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154541",
    "data-name": "Rectangle 154541",
    width: 60.951,
    height: 58.866,
    transform: "translate(0 0)",
    fill: "#481851"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154552",
    "data-name": "Rectangle 154552",
    width: 40.584,
    height: 61.296,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187916",
    "data-name": "Group 187916",
    transform: "translate(-213.248 6.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187579",
    "data-name": "Group 187579",
    transform: "translate(217.248 -6.851)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187578",
    "data-name": "Group 187578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187577",
    "data-name": "Group 187577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38078",
    "data-name": "Path 38078",
    d: "M795.589,405.582a8.919,8.919,0,0,0-12.611,0L771.558,417l12.614,12.614,11.42-11.42a8.919,8.919,0,0,0,0-12.613",
    transform: "translate(-757.528 -402.97)",
    fill: "#703289",
    stroke: "#703289",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38079",
    "data-name": "Path 38079",
    d: "M744.733,458.36a8.843,8.843,0,0,1,.816-1.551,8.843,8.843,0,0,0-.816,1.551",
    transform: "translate(-744.08 -429.96)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38080",
    "data-name": "Path 38080",
    d: "M773.312,475.76c.107-.1.219-.187.322-.291l3.806-3.806-3.806,3.806c-.1.1-.214.193-.322.291",
    transform: "translate(-758.407 -437.407)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38081",
    "data-name": "Path 38081",
    d: "M748.236,445.257a7.635,7.635,0,1,0,10.8,10.8l10.51-10.509-10.8-10.8Z",
    transform: "translate(-744.715 -418.9)",
    fill: "#ffa4dc",
    stroke: "#ffa4dc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38082",
    "data-name": "Path 38082",
    d: "M744.077,459.92a8.967,8.967,0,0,0-.287,5.895,8.967,8.967,0,0,1,.287-5.895",
    transform: "translate(-743.424 -431.52)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38083",
    "data-name": "Path 38083",
    d: "M763.906,431.106l-7.611,7.611Z",
    transform: "translate(-749.877 -417.075)",
    fill: "#c8dfe5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187585",
    "data-name": "Group 187585",
    transform: "translate(237.586 58.124) rotate(-79)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_187584",
    "data-name": "Group 187584",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187583",
    "data-name": "Group 187583",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38091",
    "data-name": "Path 38091",
    d: "M59.292,34.782,22.255,1.3a5.042,5.042,0,0,0-7.121.359L1.3,16.962a5.041,5.041,0,0,0,.359,7.121L38.7,57.564a5.042,5.042,0,0,0,7.121-.359L59.651,41.9a5.041,5.041,0,0,0-.359-7.121M13.776,22.03a3.577,3.577,0,1,1-.255-5.052,3.578,3.578,0,0,1,.255,5.052M16.124,8.764a3.577,3.577,0,1,1,.255,5.053,3.577,3.577,0,0,1-.255-5.053m5.416,20.284A3.577,3.577,0,1,1,21.285,24a3.577,3.577,0,0,1,.255,5.053m2.348-13.266a3.577,3.577,0,1,1,.255,5.053,3.577,3.577,0,0,1-.255-5.053M29.3,36.065a3.577,3.577,0,1,1-.255-5.053,3.577,3.577,0,0,1,.255,5.053m1.524-11.711a3.58,3.58,0,0,1,4.655-2.535c.11.038.218.082.324.131a3.577,3.577,0,1,1-4.582,5.069,3.465,3.465,0,0,1-.163-.31,3.59,3.59,0,0,1-.234-2.356M37.954,41.19a3.575,3.575,0,0,1-3.7,3.068,3.6,3.6,0,0,1-.877-.155c-.081-.025-.162-.052-.242-.083a3.54,3.54,0,0,1-2.038-2.013,3.556,3.556,0,0,1-.059-2.5,3.576,3.576,0,0,1,2.13-2.173,3.563,3.563,0,0,1,3.648.7,3.581,3.581,0,0,1,1.143,3.159m.974-10.681q.085-.156.187-.306a3.583,3.583,0,0,1,.3-.385,3.626,3.626,0,0,1,.259-.259,3.553,3.553,0,0,1,1.2-.717,3.58,3.58,0,0,1,3.589.721,3.575,3.575,0,0,1,.684,4.469,3.559,3.559,0,0,1-1.7,1.481,3.5,3.5,0,0,1-.422.147,3.582,3.582,0,0,1-1.121.131c-.114-.005-.229-.016-.343-.032a3.572,3.572,0,0,1-2.634-5.25m6.627,18.371a3.592,3.592,0,0,1-3.165,2.392l-.034,0A3.586,3.586,0,0,1,41,51.081c-.11-.038-.218-.082-.325-.131a3.532,3.532,0,0,1-.613-.363,3.4,3.4,0,0,1-.284-.231c-.046-.041-.086-.086-.13-.13q-.123-.123-.231-.254a3.569,3.569,0,0,1,.106-4.669,3.6,3.6,0,0,1,.259-.259,3.579,3.579,0,0,1,5.774,3.835m6.93-7.247a3.6,3.6,0,0,1-.538.486,3.549,3.549,0,0,1-1.025.519,3.59,3.59,0,0,1-1.6.138c-.114-.016-.227-.038-.339-.065a3.581,3.581,0,0,1-2.695-2.955c-.016-.113-.027-.227-.033-.342s-.006-.229,0-.343a3.548,3.548,0,0,1,1.6-2.817q.146-.1.3-.178a3.452,3.452,0,0,1,1.495-.415c.114-.005.229-.006.343,0A3.571,3.571,0,0,1,53.131,40.6a3.554,3.554,0,0,1-.647,1.028",
    transform: "translate(0 0)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38092",
    "data-name": "Path 38092",
    d: "M1.6,0A3.551,3.551,0,0,0,0,2.817,3.551,3.551,0,0,1,1.6,0",
    transform: "translate(46.256 36.254)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38093",
    "data-name": "Path 38093",
    d: "M0,0A3.564,3.564,0,0,0,1.14,2.132a3.562,3.562,0,0,0,1.555.823A3.562,3.562,0,0,1,1.14,2.132,3.566,3.566,0,0,1,0,0",
    transform: "translate(46.291 39.756)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38094",
    "data-name": "Path 38094",
    d: "M.6.764A2.323,2.323,0,0,0,2.44,4.641,2.323,2.323,0,1,0,.6.764",
    transform: "translate(47.507 36.912)",
    fill: "#703289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38095",
    "data-name": "Path 38095",
    d: "M0,0A3.63,3.63,0,0,1,.681.1,3.63,3.63,0,0,0,0,0",
    transform: "translate(49.993 35.66)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38096",
    "data-name": "Path 38096",
    d: "M1.025,0A3.563,3.563,0,0,1,0,.519,3.563,3.563,0,0,0,1.025,0",
    transform: "translate(50.922 42.119)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38097",
    "data-name": "Path 38097",
    d: "M0,1.514a3.61,3.61,0,0,0,.538-.486A3.558,3.558,0,0,0,1.185,0,3.558,3.558,0,0,1,.538,1.028,3.61,3.61,0,0,1,0,1.514",
    transform: "translate(51.946 40.605)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38098",
    "data-name": "Path 38098",
    d: "M0,.217A3.567,3.567,0,0,1,.485,0,3.594,3.594,0,0,0,0,.217",
    transform: "translate(48.155 35.86)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38099",
    "data-name": "Path 38099",
    d: "M.613.363A3.589,3.589,0,0,1,0,0,3.589,3.589,0,0,0,.613.363",
    transform: "translate(40.06 50.587)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38100",
    "data-name": "Path 38100",
    d: "M4.642,2.2A2.323,2.323,0,0,0,.6.764,2.323,2.323,0,0,0,4.046,3.879a2.308,2.308,0,0,0,.6-1.675",
    transform: "translate(39.852 45.381)",
    fill: "#703289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38101",
    "data-name": "Path 38101",
    d: "M0,0A3.588,3.588,0,0,0,1.357.194,3.586,3.586,0,0,1,0,0",
    transform: "translate(40.998 51.081)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38102",
    "data-name": "Path 38102",
    d: "M.231.254Q.109.132,0,0,.108.132.231.254",
    transform: "translate(39.415 49.972)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38103",
    "data-name": "Path 38103",
    d: "M.454,1.568A3.586,3.586,0,0,1,.26,2.925,3.589,3.589,0,0,0,0,0,3.575,3.575,0,0,1,.454,1.568",
    transform: "translate(45.294 45.954)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38104",
    "data-name": "Path 38104",
    d: "M2.86.155A3.585,3.585,0,0,0,0,.494,3.585,3.585,0,0,1,2.86.155",
    transform: "translate(40.354 44.128)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38105",
    "data-name": "Path 38105",
    d: "M1.444,0A3.574,3.574,0,0,1,0,.4,3.574,3.574,0,0,0,1.444,0",
    transform: "translate(42.389 50.868)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38106",
    "data-name": "Path 38106",
    d: "M4.046,3.879A2.323,2.323,0,0,0,.6.764,2.323,2.323,0,0,0,4.046,3.879",
    transform: "translate(39.744 29.895)",
    fill: "#703289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38107",
    "data-name": "Path 38107",
    d: "M.423,0A3.486,3.486,0,0,1,0,.147,3.486,3.486,0,0,0,.423,0",
    transform: "translate(43.024 35.513)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38108",
    "data-name": "Path 38108",
    d: "M.672.163A3.557,3.557,0,0,1,0,0,3.561,3.561,0,0,0,.672.163",
    transform: "translate(40.889 35.595)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38109",
    "data-name": "Path 38109",
    d: "M0,.2A3.6,3.6,0,0,1,1.353,0,3.6,3.6,0,0,0,0,.2",
    transform: "translate(40.877 28.639)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38110",
    "data-name": "Path 38110",
    d: "M.247,2.9A3.589,3.589,0,0,0,0,0,3.579,3.579,0,0,1,.44,1.541,3.6,3.6,0,0,1,.247,2.9",
    transform: "translate(45.199 30.494)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38111",
    "data-name": "Path 38111",
    d: "M0,.259H0A3.652,3.652,0,0,1,.259,0,3.652,3.652,0,0,0,0,.259",
    transform: "translate(39.413 29.558)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38112",
    "data-name": "Path 38112",
    d: "M0,.306A3.471,3.471,0,0,1,.188,0,3.471,3.471,0,0,0,0,.306",
    transform: "translate(38.927 30.203)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38113",
    "data-name": "Path 38113",
    d: "M.6.764A2.322,2.322,0,0,0,2.44,4.641,2.322,2.322,0,1,0,.6.764",
    transform: "translate(32.089 38.363)",
    fill: "#703289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38114",
    "data-name": "Path 38114",
    d: "M1.559,1.893A3.567,3.567,0,0,0,.583.429,3.61,3.61,0,0,0,0,0,3.58,3.58,0,0,1,.583.429a3.572,3.572,0,0,1,.976,1.464",
    transform: "translate(36.227 37.602)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38115",
    "data-name": "Path 38115",
    d: "M0,2.575a3.573,3.573,0,0,0,.833-.681A3.561,3.561,0,0,0,1.721,0,3.559,3.559,0,0,1,.832,1.893,3.563,3.563,0,0,1,0,2.575",
    transform: "translate(36.233 41.19)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38116",
    "data-name": "Path 38116",
    d: "M0,0A3.562,3.562,0,0,0,.921,1.33a3.571,3.571,0,0,0,1.117.683A3.571,3.571,0,0,1,.921,1.33,3.562,3.562,0,0,1,0,0",
    transform: "translate(31.092 42.008)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38117",
    "data-name": "Path 38117",
    d: "M0,.07A3.6,3.6,0,0,1,.85,0,3.6,3.6,0,0,0,0,.07",
    transform: "translate(33.725 37.108)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38118",
    "data-name": "Path 38118",
    d: "M0,.951A3.558,3.558,0,0,1,1.4,0,3.558,3.558,0,0,0,0,.951",
    transform: "translate(31.758 37.334)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38119",
    "data-name": "Path 38119",
    d: "M.877.155A3.571,3.571,0,0,1,0,0,3.571,3.571,0,0,0,.877.155",
    transform: "translate(33.372 44.103)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38120",
    "data-name": "Path 38120",
    d: "M.725,0A3.563,3.563,0,0,0,0,1.222,3.563,3.563,0,0,1,.725,0",
    transform: "translate(31.033 38.285)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38121",
    "data-name": "Path 38121",
    d: "M.681,2.083A3.571,3.571,0,0,1,0,1.251a3.571,3.571,0,0,0,.681.832,3.577,3.577,0,0,0,5.053-.255A3.554,3.554,0,0,0,6.61,0a3.558,3.558,0,0,1-.876,1.829,3.577,3.577,0,0,1-5.053.255",
    transform: "translate(31.223 25.769)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38122",
    "data-name": "Path 38122",
    d: "M2.44,4.641A2.323,2.323,0,0,0,4.642,2.2,2.322,2.322,0,0,0,.6.764,2.322,2.322,0,0,0,2.44,4.641",
    transform: "translate(31.981 22.877)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38123",
    "data-name": "Path 38123",
    d: "M1.984,2.455A3.559,3.559,0,0,0,.9.593,3.577,3.577,0,0,0,0,0,3.577,3.577,0,0,1,.9.593,3.559,3.559,0,0,1,1.984,2.455",
    transform: "translate(35.805 21.951)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38124",
    "data-name": "Path 38124",
    d: "M4.654.2A3.579,3.579,0,0,0,0,2.733,3.579,3.579,0,0,1,4.654.2",
    transform: "translate(30.827 21.622)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38125",
    "data-name": "Path 38125",
    d: "M.924,1.178A3.577,3.577,0,1,0,5.976.924a3.577,3.577,0,0,0-5.053.255",
    transform: "translate(23.071 30.089)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38126",
    "data-name": "Path 38126",
    d: "M6.231,5.976a3.577,3.577,0,1,0-5.053.255,3.577,3.577,0,0,0,5.053-.255",
    transform: "translate(22.963 14.603)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38127",
    "data-name": "Path 38127",
    d: "M.924,1.178A3.577,3.577,0,1,0,5.976.924a3.577,3.577,0,0,0-5.053.255",
    transform: "translate(15.308 23.072)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38128",
    "data-name": "Path 38128",
    d: "M6.231,5.976a3.577,3.577,0,1,0-5.053.255,3.577,3.577,0,0,0,5.053-.255",
    transform: "translate(15.2 7.586)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38129",
    "data-name": "Path 38129",
    d: "M.924,1.178A3.577,3.577,0,1,0,5.976.924a3.577,3.577,0,0,0-5.053.255",
    transform: "translate(7.545 16.054)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38130",
    "data-name": "Path 38130",
    d: "M7.15,3.4A3.576,3.576,0,0,0,3.74,0C3.626,0,3.512,0,3.4,0a3.6,3.6,0,0,0-1.01.2A3.567,3.567,0,0,0,1.9.42C1.8.474,1.7.533,1.6.6A3.545,3.545,0,0,0,0,3.414C0,3.529,0,3.643,0,3.758s.017.228.034.342A3.58,3.58,0,0,0,2.733,7.054c.112.027.225.049.339.065A3.585,3.585,0,0,0,7.15,3.4M5.3,5.135A2.322,2.322,0,1,1,5.9,3.46a2.308,2.308,0,0,1-.6,1.675",
    transform: "translate(46.252 35.657)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38131",
    "data-name": "Path 38131",
    d: "M7.15,3.395A3.577,3.577,0,1,0,.817,5.844c.072.088.15.173.231.254.043.043.084.088.13.13a3.614,3.614,0,0,0,.284.231,3.551,3.551,0,0,0,.613.363c.106.049.214.093.324.131a3.585,3.585,0,0,0,1.357.194l.034,0A3.573,3.573,0,0,0,7.15,3.395M2.02,5.3A2.322,2.322,0,1,1,5.3,5.132,2.3,2.3,0,0,1,2.02,5.3",
    transform: "translate(38.597 44.128)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38132",
    "data-name": "Path 38132",
    d: "M1.178,6.231a3.564,3.564,0,0,0,1.893.888q.17.024.342.032a3.58,3.58,0,0,0,1.121-.131,3.5,3.5,0,0,0,.423-.147,3.564,3.564,0,0,0,1.273-.9,3.622,3.622,0,0,0,.429-.583A3.577,3.577,0,0,0,.923,1.179a3.5,3.5,0,0,0-.3.385,3.473,3.473,0,0,0-.187.306,3.569,3.569,0,0,0,.741,4.361M1.854,2.02a2.321,2.321,0,1,1-.6,1.675,2.325,2.325,0,0,1,.6-1.675",
    transform: "translate(38.489 28.639)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38133",
    "data-name": "Path 38133",
    d: "M6.952,2.387A3.564,3.564,0,0,0,5.976.923,3.6,3.6,0,0,0,5.393.494,3.563,3.563,0,0,0,3.74,0,3.625,3.625,0,0,0,2.891.07,3.569,3.569,0,0,0,.2,2.4,3.569,3.569,0,0,0,2.3,6.914q.12.046.241.082A3.575,3.575,0,0,0,7.119,4.082a3.6,3.6,0,0,0-.168-1.7M5.3,5.135A2.323,2.323,0,1,1,5.9,3.46a2.306,2.306,0,0,1-.6,1.675",
    transform: "translate(30.834 37.107)",
    fill: "#481851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38134",
    "data-name": "Path 38134",
    d: "M.5,5.4A3.577,3.577,0,1,0,5.079.329C4.973.28,4.864.237,4.755.2A3.58,3.58,0,0,0,.334,5.089c.049.105.1.208.163.31M1.854,2.02a2.323,2.323,0,1,1-.6,1.675,2.325,2.325,0,0,1,.6-1.675",
    transform: "translate(30.726 21.622)",
    fill: "#703289"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187615",
    "data-name": "Group 187615",
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 243.653, 79.578)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_187614",
    "data-name": "Group 187614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187613",
    "data-name": "Group 187613",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38525",
    "data-name": "Path 38525",
    d: "M39.7,14.558C35.854,3.452,24.094-2.6,13.487,1.074s-16.105,15.7-12.261,26.8C4.92,38.546,34.335,61.3,34.335,61.3S43.392,25.227,39.7,14.558M25.338,35.3A15.313,15.313,0,0,1,12.489,34c-.094-.056-.187-.111-.28-.169q-.493-.307-.964-.651a15.29,15.29,0,0,1-1.206-.978l-.108-.1A15.353,15.353,0,0,1,12.473,7.6a15.449,15.449,0,0,1,2.821-1.308c.435-.151.872-.276,1.31-.386.11-.027.22-.055.33-.08a15.281,15.281,0,0,1,3.651-.38l.032,0q.7.014,1.392.092a15.334,15.334,0,0,1,3.329.758c.156.054.311.109.465.168A15.348,15.348,0,0,1,25.338,35.3",
    transform: "translate(0 0)",
    fill: "#703289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38526",
    "data-name": "Path 38526",
    d: "M0,0Q.7.014,1.392.092.7.015,0,0",
    transform: "translate(20.619 5.444)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38527",
    "data-name": "Path 38527",
    d: "M.279.168C.186.113.092.057,0,0,.092.057.186.113.279.168",
    transform: "translate(12.209 33.828)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38528",
    "data-name": "Path 38528",
    d: "M4.132,0c-.438.11-.875.236-1.31.386A15.458,15.458,0,0,0,0,1.693,15.458,15.458,0,0,1,2.822.386C3.256.236,3.694.11,4.132,0",
    transform: "translate(12.473 5.903)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38529",
    "data-name": "Path 38529",
    d: "M.849,15.383A15.348,15.348,0,0,1,4.024,0,15.36,15.36,0,0,0,4.97,21.669,15.278,15.278,0,0,1,.849,15.383",
    transform: "translate(4.962 10.433)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38530",
    "data-name": "Path 38530",
    d: "M18.144,26.591A13.671,13.671,0,1,0,.753,18.144a13.687,13.687,0,0,0,17.391,8.447M6.067,19.55l-2.006-5.8,5.71-1.976L7.794,6.067l5.8-2.007,1.977,5.71,5.71-1.977,2.006,5.8-5.71,1.977,1.977,5.71-5.8,2.006-1.977-5.71Z",
    transform: "translate(6.644 7.123)",
    fill: "#fff1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38531",
    "data-name": "Path 38531",
    d: "M0,0C.156.054.312.109.466.169.312.109.156.054,0,0",
    transform: "translate(25.34 6.294)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38532",
    "data-name": "Path 38532",
    d: "M3.487,0A15.242,15.242,0,0,0,0,2.838,15.242,15.242,0,0,1,3.487,0",
    transform: "translate(8.986 7.596)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38533",
    "data-name": "Path 38533",
    d: "M1.206.978A15.417,15.417,0,0,1,0,0,15.417,15.417,0,0,0,1.206.978",
    transform: "translate(10.039 32.198)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38534",
    "data-name": "Path 38534",
    d: "M0,.383A15.267,15.267,0,0,1,3.652,0,15.267,15.267,0,0,0,0,.383",
    transform: "translate(16.935 5.44)",
    fill: "#c8dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38535",
    "data-name": "Path 38535",
    d: "M15.489,17.216l-1.977-5.71,5.71-1.977-2.007-5.8L11.506,5.71,9.529,0l-5.8,2.006L5.71,7.717,0,9.693l2.006,5.8,5.71-1.977,1.977,5.71Z",
    transform: "translate(10.705 11.184)",
    fill: "#c0348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38536",
    "data-name": "Path 38536",
    d: "M20.843,1.022c-.154-.059-.31-.114-.465-.168A15.345,15.345,0,0,0,17.048.1Q16.358.019,15.656,0l-.032,0a15.281,15.281,0,0,0-3.651.38c-.11.025-.22.052-.331.08-.438.11-.875.236-1.31.386A15.426,15.426,0,0,0,7.511,2.156,15.358,15.358,0,0,0,4.97,26.662l.107.1a15.367,15.367,0,0,0,1.206.978q.47.344.964.651c.093.057.186.113.279.169A15.348,15.348,0,1,0,20.843,1.022M2.435,19.827a13.671,13.671,0,1,1,17.391,8.447A13.687,13.687,0,0,1,2.435,19.827",
    transform: "translate(4.962 5.44)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelineBackground2);
export default __webpack_public_path__ + "static/media/guideline-background-2.e03e85e49e2871eb61315e99d47ed3c3.svg";
export { ForwardRef as ReactComponent };